<template>
  <div>
        <banner>
            <div class="huoyuanxx">
                <div style="font-size:36px;">客户服务</div>
                <div style="margin-top:18px;font-size:18px;line-height:28px;">急速匹配、货源发布，从联系我们开始</div>
            </div>
        </banner>
        <div class="shidata">
            <div class="sstit">
                <div class="dabt">联系我们</div>
                <div>我们诚邀全球最优秀的人才加入我们，成功路上，我们结伴同行</div>
            </div>
            <div class="lianxwm">
                <div class="lxwmnr">
                    <img src="@/assets/lianxwm.png" width="86" height="86" />
                    <div>
                        服务热线：<span>{{wzinfor.basicTelephone}}</span>
                    </div>
                </div>
                <div class="lxwmnr">
                    <img src="@/assets/youxiang.png" width="86" height="86" />
                    <div>
                        联系邮箱：<span>{{wzinfor.basicEmail}}</span>
                    </div>
                </div>
                <div class="lxwmnr">
                    <img src="@/assets/weizhi.png" width="86" height="86" />
                    <div>
                        公司地址：<span>{{wzinfor.basicCompanyAddress}}</span>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import Banner from '../components/banner/banner'
import { mapState } from 'vuex'
export default {
    data(){
        return {
           wzinfor:{}
        }
    },
    components:{
        Banner
    },
    computed:{
        ...mapState(['infor'])
    },
    methods:{
       
    },
    watch:{
        infor(){
            this.wzinfor = this.infor
        }
    },
    created(){
        this.wzinfor = this.infor   // this.$store.state.infor
    }
}
</script>

<style lang="stylus" scoped>
    .huoyuanxx
        padding-top: 80px
        color: #fff
    .shidata
        width: 1400px
        margin: 0 auto
        padding: 70px
        background: #fff
        .sstit
            text-align: center
            .dabt
                margin-bottom: 15px
                font-size: 24px
                color: #08599A
                font-weight: bold
        .lianxwm
            display:-webkit-box
            display: -webkit-flex
            display: flex
            margin-top: 90px
            align-items:center 
            justify-content:space-around
            .lxwmnr
                font-size: 16px
                text-align:center
                div
                    margin-top: 15px
                    span
                         font-weight: bold               

</style>